// components/PublicRoute.jsx
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PublicRoute = ({ children }) => {
  const data = JSON.parse(localStorage.getItem("admin"));
  const token = data?.token;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        // Token expired
        localStorage.removeItem("admin");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        return children;
      }

      const role = decoded.role;

      // Redirect other roles away from public pages
      if (role === "admin") return <Navigate to="/Admin" />;
      if (role === "dental") return <Navigate to="/dental/profile" />;
    //   if (role === "parent") return <Navigate to="/parent/dashboard" />;
    //   if (role === "manager") return <Navigate to="/manager/dashboard" />;

      // Allow if role is student
      return children;
    } catch (error) {
      // Corrupt or invalid token
      localStorage.clear();
      return children;
    }
  }

  // No token: treat as guest
  return children;
};

export default PublicRoute;
